import React from "react";
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { pathOr } from "ramda";
import { Divider } from "@mui/material";
import '../index.css'
import { formatCurrency } from "../helpers/formatter";
import moment from 'moment'

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(1),
  textAlign: 'center',
}));

const AdditionalInfo = (props) => {
    const { policy } = props
    const status = pathOr('', ['policyStatus'], policy)
    const savingType=pathOr('',['savingType'],policy)

    return (
    <>

        {status != 'Inforce' && savingType=='Traditional' && 
            <>
            <Grid container spacing={1} style={{backgroundColor: '#F1F7F0',padding:'10px',borderRadius:6}}>
                <Grid item size={6} spacing={1}> 
                    <Item>
                    <Typography color='#40812F' variant={'h5'} align='center'>₹ {formatCurrency(policy.totalPremiumPaid)}</Typography>
                        <Typography variant={'body2'} align='center'>{'Total Premium Paid'}</Typography>
                    </Item>
                </Grid>
                <Grid item size={6} spacing={1}> 
<Item>
                    <Typography color='#40812F' variant={'h5'} align='center'>₹ {formatCurrency(policy.pendingPremium)}</Typography>
                        <Typography variant={'body2'} align='center'>{'Pending Premium'}</Typography>
                    </Item>
                </Grid>
            </Grid>
            <Grid container mt={2} style={{ backgroundColor: '#F1F7F0', padding:'10px'}}>
                <Grid item size={4} className="aligcenter">
                    <Typography className="customFont" textAlign={'center'} variant={'h6'} align={'center'}>{'Accrued Bonus'}</Typography>
                    <Typography color='#40812F' variant={'h6'} align='center'>₹ {formatCurrency(policy.bonusTillDate)}</Typography>
                </Grid>
                <Divider className="hideInMobile" orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                <Grid item size={4} className="aligcenter">
                    <Typography  className="customFont" variant={'h6'} align='center'>{'Paid Up Value'}</Typography>
                    <Typography color='#40812F' variant={'h6'} align='center'>₹ {formatCurrency(policy.surrenderValue)}</Typography>
                </Grid>
                <Divider className="hideInMobile" orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                <Grid item size={4} className="aligcenter">
                    <Typography className="customFont" variant={'h6'} align='center'>{'Maturity Date'}</Typography>
                    <Typography color='#40812F' variant={'h6'} align='center'>{`${moment(policy.commencementDate).add(policy.term,'years').format('DD-MM-YYYY')}`}</Typography>
                </Grid> 
            </Grid>
            <Grid container style={{background:'#387129', padding:'10px'}}>
                <Grid item size={12} mb={2}>
                    <Typography variant="body1" color="#FAAD14">{'If you revive today..'}</Typography>
                </Grid>
                <Grid item size={6} className="aligcenter">
                    <Typography color='#fff' variant={'h6'} align='center'>₹ {formatCurrency(policy.approxBonusAmt)}</Typography>
                    <Typography className="customFont" color="#fff" variant={'h6'} align='center'>{'Approx. Bonus Amount'}</Typography>
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mr: "-1px",bgcolor:'#fff' }} />
                <Grid item size={6} className="aligcenter">
                    <Typography color='#fff' variant={'h6'} align='center'>₹ {formatCurrency(policy.approxMaturityAmt)}</Typography>
                    <Typography className="customFont" color="#fff" variant={'h6'} align='center'>{'Approx. Maturity Amount'}</Typography>
                </Grid>
            </Grid>
            </>
        }
        {savingType == 'ULIP' && 
            <>
            <Grid container mt={2} style={{ backgroundColor: '#F1F7F0', padding:'10px'}}>
{/*                 <Grid item size={4} className="aligcenter">
                    <Typography className="customFont" variant={'h6'} align='center'>{'IRR'}</Typography>
                    <Typography color='#40812F' variant={'h6'} align='center'>{Math.ceil(policy.xirr * 100)}%</Typography>
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} /> */}
                <Grid item size={6} className="aligcenter">
                    <Typography className="customFont" variant={'h6'} align='center'>{'Total Premium Paid'}</Typography>
                    <Typography color='#40812F' variant={'h6'} align='center'>₹ {formatCurrency(policy.totalPremiumPaid)}</Typography>
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                <Grid item size={6} className="aligcenter">
                    <Typography className="customFont" variant={'h6'} align='center'>{'Fund Value'}</Typography>
                    <Typography color='#40812F' variant={'h6'} align='center'>₹ {formatCurrency(policy.fundValue)}</Typography>
                </Grid> 
                </Grid>
                {status != 'Inforce' && savingType == 'ULIP' && 
                <Grid container style={{ backgroundColor: '#387129', padding:'10px'}}>
                    
                    <Grid item size={6} className="aligcenter">
                        <Typography alignContent={'center'} mr={1} color="#fff" variant={'caption'} align='center'>{'Approx. Liquidation Amt'}</Typography>
                        <Typography color='#fff' variant={'h6'} align='center'>₹ {formatCurrency(pathOr(0,['oneView','policy','maturityIfNotRevive'],policy))}</Typography>
                    </Grid>
                    <Divider orientation="vertical" flexItem sx={{ mr: "-1px", background:'#fff' }} />
             
                    <Grid item size={6} className="aligcenter">
                        <Typography alignContent={'center'} mr={1} color="#fff" variant={'caption'} align='center'>{' Liquidation Date'}</Typography>
                        <Typography color='#fff' variant={'h6'} align='center'>{moment(policy.commencementDate).add(5, 'years').format("DD-MM-YYYY")}</Typography>
                    </Grid>
                </Grid>
                }
                
            </>
        }
   </>     
    );
       
}

export default AdditionalInfo